import { render, staticRenderFns } from "./SelectImagePanel.vue?vue&type=template&id=3b3842a0&scoped=true&"
import script from "./SelectImagePanel.vue?vue&type=script&lang=js&"
export * from "./SelectImagePanel.vue?vue&type=script&lang=js&"
import style0 from "./SelectImagePanel.vue?vue&type=style&index=0&id=3b3842a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3842a0",
  null
  
)

export default component.exports